import React from 'react';
import './SongCard.css';

export default function SongCard({ song, isPlaying, onPlay, onRemove, showRemove }) {
  return (
    <div className={`song-card ${isPlaying ? 'playing' : ''}`}>
      <div className="song-cover" onClick={() => onPlay(song)}>
        <img src={song.cover} alt={song.album} loading="lazy" />
        <div className="play-overlay">
          <span className="play-icon">{isPlaying ? '❚❚' : '▶'}</span>
        </div>
      </div>
      <div className="song-info">
        <h4 className="song-title">{song.title}</h4>
        <p className="song-artist">{song.artist}</p>
        <div className="song-meta">
          <span className="song-album">{song.album}</span>
          <span className="song-year">{song.year}</span>
        </div>
        <div className="song-tags">
          <span className="tag tempo-tag">{song.tempo === 'fast' ? '⚡' : song.tempo === 'slow' ? '🐢' : '🚶'} {song.tempo}</span>
          <span className="tag energy-tag">
            {song.energy === 'high' ? '🔥' : song.energy === 'low' ? '❄️' : '💧'} {song.energy}
          </span>
          <span className="tag bpm-tag">{song.bpm} BPM</span>
        </div>
      </div>
      {showRemove && (
        <button className="remove-btn" onClick={() => onRemove(song.id)} title="移除">×</button>
      )}
    </div>
  );
}
